import { API } from "../../API_CONFIG"
const BASE_URL = API.providerNode
export const URL = {
    providercore_url : BASE_URL+"/",
    s3_upload_image_url : "https://providercore.medibuddy.in/provider/Uploadfile",
    mb_wapi : "https://www.medibuddy.in/WAPI/",
    api_plus : "https://api-plus.medibuddy.in/",
    ins_medibuddy : "https://ins-integration.medibuddy.in/",
    procheck : "https://ch-api-procheck.medibuddy.in/",
    cleverTap: "https://api.clevertap.com/1/upload",
    plus_api_prod : "https://plus-api-prod.medibuddy.in/",
    consults_backend: API.consults_core_backend+'/',
    vision_url: API.vision_core_url+'/'
}

export const USER = {
    access_token : localStorage.getItem("access_token") ?  localStorage.getItem("access_token") : '',
    user : localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem("user_details")) : [],
   } 
   
export const STATUS_CODE_MAP = {
    "New Appointment Request":22,
    "Confirmed by Medical Center":23,
    "Confirmed by Ops":24,
    "Cancelled by Medical Center":26,
    "Rescheduled by Medical Center":29,
    "Rescheduled by Ops":30,
    "Rescheduled by User":31,
    "Attended":32,
    "Information Awaited":33,
    "Info submitted":37,
    "Not Attended":39,
    "Customer awaited at DC":40,
    "Cancelled":42,
    "QCApproved":48,
    "Partially Attended":116,
    "NotAttended by Others":118,
    "Cancelled by Insurer":119,
    "Closed by Insurer":120,
    "TU Completed":121,
    "TU Scheduled":122,
    "TU Information Awaited":123,
    "Fit with recommendation":126,
    "Fitness on Hold":127,
    "Temporary unfit":128,
    "System Confirmed":129,
    "Non Workable":130,
    "Digitization Pending":134, 
    "ReportProcessPending":140,
    "Rejected":146,
    "Branch Approval Pending":161,
    "Partial Report Uploaded":162,
}

export const ProvidersAffiliateOrders = [419652,407516]
export const ProviderAffiliateOrdersName = {
    419652: "Diagright",
    407516: "Lifecare",
    422069: "VBS",
}

export const SERVICE_NAME_OFFLINE_CONSULTS = 'OFFLINE_CONSULTS';
export const SERVICE_NAME_LABS = 'LABS';
export const SERVICE_NAME_VISION = 'VISION';
export const LOCAl_STORAGE_KEY_VALID_SERVICES = 'ValidServices';

export const TEST_FOR_HA_CASES = ['cat 12', 'cat12','cat 13', 'cat13','cat 14', 'cat14','cat 32', 'cat32','cat-33', 'cat33','cat-34', 'cat34','cat-35', 'cat35','cat 37', 'cat37']

export const SLA_FILTERS = {
    "New Appointments" :  "RequestCreationDate",
    "Confirmed Appointments" : "RequestFulfillmentDate",
    "Documents Pending" : "RequestModificationDate"
}

export const SLA_FILTER_TIME = {
    "RequestCreationDate" : 12 ,
    "RequestFulfillmentDate" : 4 ,
    "RequestModificationDate" : 24
}

export const CLEVER_TAP_EVENTS = {
    loginVisited:"Labwise Landing on Home Page",
    loginAttempted:"Labwise Logging into portal",
    loginSuccess:"Labwise Login Sucess",
    loginFailed:"Labwise Login Failed",
    otpVerificaiton: "Labwise Verifying OTP", 

    newApptVisited:"Labwise New Appointments Tab",
    // confirmBtnClick:"Labwise Clicking on Individual Confirm Button",
    // confirmPopupShown:"Labwise Individual Confirm popup shown",
    // confirmPopupBtnClick:"Labwise Individual Confirm popup click",
    confirmedApptSuccess:"Labwise Individual Confirm success",
    confirmedApptFailed:"Labwise Individual Confirm Failure",
    
    rejectApptSuccess:"Labwise Individual Reject success",

    bulkConfirmBtnClick:"Labwise Bulk Confirm Appointment clicked",
    // bulkConfirmPopupShown:"Labwise Bulk Appointment Confirm Popup Shown",
    // bulkConfirmPopupBtnClick:"Labwise Bulk Appointment Final Confirm clicked",
    bulkConfirmedApptSuccess:"Labwise Bulk Appointment Confirm Success",
    // bulkConfirmedApptFailed:"Labwise Bulk Appointment Confirm Failure",
    
    confirmedApptVisited:"Labwise Confirmed Appointments tab clicked",
    // markAttendedBtnClick:"Labwise Mark Attendance button clicked",
    // markAttendedPopupShown:"Labwise Mark Attended Popup shown",
    markAttendedPopupBtnClick:"Labwise MarkAttended on popup clicked",
    markAttendedSuccess:"Labwise Mark Attendance function success",
    // markAttendedFailed:"Labwise Mark Attendance function failure",

    // markNotAttendedBtnClick:"Labwise Mark Not Attendance button clicked",
    // markNotAttendedPopupShown:"Labwise Mark Not Attendance popup shown",
    markNotAttendedPopupBtnClick:"Labwise Mark Not Attendance popup clicked",
    markNotAttendedSuccess:"Labwise Not Mark Attendance function success",
    // markNotAttendedFailed:"Labwise Not Mark Attendance function failure",
    
    // bulkMarkAttendedBtnClick:"Labwise Bulk Attendance Click",
    // bulkMarkAttendedPopupShown:"Labwise Bulk Attendance Popup Shown",
    // bulkMarkAttendedPopupBtnClick:"Labwise Bulk Attendance Final Click",
    bulkMarkAttendedSuccess:"Labwise Mark Bulk Attendance Success",
    // bulkMarkAttendedFailed:"Labwise Bulk Attendance Failure",

    // attachDocIconClick:"Labwise Attach Document Click",
    // attachDocsPopupShown:"Labwise Submit Document Popup Shown",
    // attachReportsClick:"Labwise Attach Lab Reports Clicked",
    // uploadReportFailed:"Labwise Attach Lab Reports Failed",
    // attachBillsClick:"Labwise Attach Bills Clicked",
    // uploadBillsFailed:"Labwise Attach Bills failed",
    attachDocsFinalClick:"Labwise Documents Final Submit Click",
}

export const BRANCH_WHITELISTED_PROVIDERS = [50500,408076,380628,421965,42236,419384,42236,430765,430797];
export const QCSTATE_PROVIDERS=[422943,387402];

export const ValidateLocalStorageToken = (token) => {
    try {
        return JSON.parse(token);
    } catch(err) {
        console.log(err?.message);
        return null;
    }
}

// export const AppID = 10007;
export const AppID = 9203;
export const HotjarId = 4985984;

export const labsTabs = [
    { id: 1, name: "New Appointments", route: "/appointments" },
    { id: 2, name: "Confirmed Appointments", route: "/appointments/confirmed" },
    { id: 3, name: "Documents Pending", route: "/documents/pending" },
    { id: 4, name: "Partial Documents Submitted", route: "/documents/partialReceived" },
    { id: 5, name: "Documents Submitted", route: "/documents/received" },
    { id: 6, name: "Settled", route: "/cases/settled" },
    { id: 7, name: "Cancelled", route: "/cases/cancelled" },
    { id: 8, name: "Rejected", route: "/cases/rejected" },
    { id: 9, name: "Not Attended", route: "/appointments/notAttended" },
    { id: 10, name: "All Appointments", route: "/appointments/all" },
];

export const rejectedReasons = ["Unavailability Of Slots", "No Bandwidth", "Holidays", "Others"];

export const notAttendedReasons = [
    "Customer not answering the calls",
    "The customer was not available for sample collection & wants to reschedule",
    "The customer was not available for sample collection & wants to cancel ",
    "Others",
];

export const ppmcContracts = [9782, 4625];

export const corporateIdsMERFormApplicable = [421421,421808,430689,421421,436307,440249,470541,443957,60521,455516,455032,449280,455576,376593,592104,421652,419000,421652,468400];

export const InsurerErIDs = {
    'sms': [],
    'call': [],
    'email': [],
    'whatsapp': [192514]
  };

export const DC_ROLES = ["DC_Admin", "DC_Operations", "DC_Finance"];

export const HAMBURGER_NO_CODE_URL = [
    { id: 1, name: "Organization setting", route: "https://healthverse.medibuddy.in/provider-central-1" },
    { id: 2, name: "Insights and finance", route: "https://healthverse.medibuddy.in/provider-central-2" },
    { id: 3, name: "Order Insights", route: "https://healthverse.medibuddy.in/provider-analytics" },
    { id: 4, name: "Grievances", route: "https://healthverse.medibuddy.in/provider-central-3" },
    { id: 5, name: "Advertisement", route: "https://healthverse.medibuddy.in/provider-central-4" },
];

export const visionTabs = [
    { id: 1, name: "Action Pending", route: "/vision/actionPending" },
    { id: 2, name: "Payment Pending", route: "/vision/paymentPending" },
    { id: 3, name: "Approved for Production", route: "/vision/readyForManufacturing" },
    { id: 4, name: "In Production", route: "/vision/pickedForManufacturing" },
    { id: 5, name: "Ready For Pickup", route: "/vision/readyForPickup" },
    { id: 6, name: "Delivered", route: "/vision/delivered" },
];  
